export const editRouteMapping = (builder) => ({
    editRouteMapping: builder.mutation({
      query: (body) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/edit_route_for_enterprise_user',
          method: 'PUT',
          body: body,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  
  